import React, { useEffect, useState } from "react";
import ListHeader from "../../../../../components/listing/ListHeader";
import ListFooter from "../../../../../components/listing/ListFooter";
import DynamicTable from "../../../../../components/listing/DynamicTable";
import FiltroMoneda from "./FiltroMoneda";
import apiRoutes from "../../../../../api/apiRoutes";
import { appFetchJson } from "../../../../../utils/http";
import IconEdit from "../../../../../components/icons/IconEdit";
import IconTrash from "../../../../../components/icons/IconTrash";
import CrearMoneda from "./CrearMoneda";
import EditarMoneda from "./EditarMoneda";
import EliminarMoneda from "./EliminarMoneda";

export default function ListarMoneda() {
  const [porPagina, setPorPagina] = useState(30);
  const [pagina, setPagina] = useState(1);
  const [totalBackend, setTotalBackend] = useState(0);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadKey, setReloadKey] = useState(0);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [monedaAEditar, setMonedaAEditar] = useState(null);
  const [monedaAEliminar, setMonedaAEliminar] = useState(null);
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [filtros, setFiltros] = useState({ codigo: "", nombre: "", valorCambio: "", codigoIso: "" });

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const url = apiRoutes.monedas.listUrl({
          page: pagina - 1, size: porPagina,
          codigo: filtros.codigo.trim() || undefined,
          nombre: filtros.nombre.trim() || undefined,
          valorCambio: filtros.valorCambio || undefined,
          codigoIso: filtros.codigoIso || undefined,
        });
        const res = await appFetchJson(url);
        const items = Array.isArray(res?.items) ? res.items : [];
        setData(items);
        setTotalBackend(res?.totalElements ?? res?.total ?? items.length);
      } catch (e) {
        console.error("Error cargando monedas:", e);
        setError("Error al cargar las monedas.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  const columns = [
    { header: "Código", accessor: "codigo", type: "text", width: "20%", cellClass: "text-gray-600 font-mono" },
    { header: "Descripción", accessor: "nombre", type: "text", width: "30%", cellClass: "font-medium text-gray-800" },
    { header: "Valor Cambio", accessor: "valorCambio", type: "text", width: "20%", cellClass: "text-gray-600" },
    { header: "Código ISO", accessor: "codigoIso", type: "text", width: "15%", cellClass: "text-gray-600" },
    {
      header: "Acción", type: "action", width: "15%",
      render: (row) => (
        <div className="flex justify-center items-center gap-2">
          <button title="Editar" onClick={() => setMonedaAEditar(row)}><IconEdit /></button>
          <button title="Eliminar" onClick={() => setMonedaAEliminar(row)}><IconTrash /></button>
        </div>
      ),
    },
  ];

  return (
    <div className="page">
      <ListHeader
        title="Monedas"
        filters={filtros}
        onFilterClick={() => setMostrarFiltros(true)}
        onClearFilters={() => { setFiltros({ codigo: "", nombre: "", valorCambio: "", codigoIso: "" }); setPagina(1); }}
        showAdd={true} addLabel="Agregar" onAddClick={() => setMostrarCrear(true)}
        pageSize={porPagina} onPageSizeChange={(size) => { setPorPagina(size); setPagina(1); }}
      />
      {loading && <div className="mt-2 text-sm text-gray-600">Cargando datos...</div>}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}
      {mostrarFiltros && (
        <FiltroMoneda
          initialFilters={filtros}
          onSubmit={(nuevos) => { setFiltros(nuevos); setPagina(1); setMostrarFiltros(false); }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}
      <DynamicTable size="S" data={data} columns={columns} />
      <ListFooter page={pagina} pageSize={porPagina} total={totalBackend} onPageChange={(p) => setPagina(p)} />
      {mostrarCrear && (
        <CrearMoneda onClose={() => setMostrarCrear(false)}
          onCreated={() => { setPagina(1); setReloadKey(k => k+1); setMostrarCrear(false); }} />
      )}
      {monedaAEditar && (
        <EditarMoneda initial={monedaAEditar} onClose={() => setMonedaAEditar(null)}
          onSaved={() => { setReloadKey(k => k+1); setMonedaAEditar(null); }} />
      )}
      {monedaAEliminar && (
        <div className="modal-backdrop" onClick={() => setMonedaAEliminar(null)}>
          <div className="modal-panel-md" onClick={e => e.stopPropagation()}>
            <EliminarMoneda registro={monedaAEliminar} onClose={() => setMonedaAEliminar(null)}
              onDeleted={() => { setReloadKey(k => k+1); setMonedaAEliminar(null); }} />
          </div>
        </div>
      )}
    </div>
  );
}